import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SplashPage from './components/SplashPage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

window.location.href = 'https://shop.simbastickers.com';   // We want to do it immediately.


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SplashPage, { msg: "Welcome to Your Vue.js + TypeScript App" }))
}
}

})